import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { h as handleDismiss } from './index2.js';
import { g as getAlertOrBannerIcon } from './alert-banner-icon.js';
import { d as defineCustomElement$5 } from './close-button.js';
import { d as defineCustomElement$4 } from './icon.js';
import { d as defineCustomElement$3 } from './tooltip.js';
import { d as defineCustomElement$2 } from './tooltip-label.js';

const alertCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;align-items:center;border:none;border-radius:.375rem;box-sizing:border-box;display:inline-flex;font-family:Open Sans;font-size:.875rem;font-weight:400;gap:.75rem;letter-spacing:-.0004em;line-height:normal;line-height:1.25rem;padding:.75rem 1rem;width:100%}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}.content{align-items:flex-start;display:inline-flex;gap:.75rem;width:100%}.content wui-icon{margin:.125rem 0}:host([type=info]){background-color:var(--jw-theme-info-muted-message-bg-color);color:var(--jw-theme-info-muted-message-color)}:host([type=info]) ::slotted(a),:host([type=info]) ::slotted(a:hover){--color:var(--jw-theme-info-muted-message-color)!important;color:var(--color)!important}:host([type=error]){background-color:var(--jw-theme-error-muted-message-bg-color);color:var(--jw-theme-error-muted-message-color)}:host([type=error]) ::slotted(a),:host([type=error]) ::slotted(a:hover){--color:var(--jw-theme-error-muted-message-color)!important;color:var(--color)!important}:host([type=warning]){background-color:var(--jw-theme-warning-muted-message-bg-color);color:var(--jw-theme-warning-muted-message-color)}:host([type=warning]) ::slotted(a),:host([type=warning]) ::slotted(a:hover){--color:var(--jw-theme-warning-muted-message-color)!important;color:var(--color)!important}:host([type=success]){background-color:var(--jw-theme-success-muted-message-bg-color);color:var(--jw-theme-success-muted-message-color)}:host([type=success]) ::slotted(a),:host([type=success]) ::slotted(a:hover){--color:var(--jw-theme-success-muted-message-color)!important;color:var(--color)!important}:host([type=promo]){background-color:var(--jw-theme-promo-bg-color);border-bottom:2px solid var(--jw-theme-promo-border-color);color:var(--jw-theme-promo-text-color)}:host([type=promo]) ::slotted(a),:host([type=promo]) ::slotted(a:hover){--color:var(--jw-theme-promo-text-color)!important;color:var(--color)!important}:host([type=promo]) hr{background-color:var(--jw-theme-surface-muted-message-divider)}:host([type=promo]) .content{gap:.5rem}:host([type=promo]) h5{min-width:fit-content}h5{color:var(--jw-theme-promo-label-color);margin:0;padding:0}.actions{align-items:center;display:flex;gap:.75rem;justify-content:center}.actions hr{background-color:var(--jw-theme-surface-muted-message-divider);border:none;height:24px;width:1px}";
const WuiAlertStyle0 = alertCss;

const WuiAlert$1 = /*@__PURE__*/ proxyCustomElement(class WuiAlert extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.dismiss = createEvent(this, "dismiss", 3);
        this.handleDismiss = () => handleDismiss(this);
        this.dismissible = true;
        this.type = 'info';
        this.promoLabel = 'NEW! 🎉';
    }
    render() {
        const icon = getAlertOrBannerIcon(this.type);
        return (h(Host, { key: '21ce1958a415f0bd41216b34ca874bd749d97efe' }, h("div", { key: '3cedd9cf0ee0d3fa8b58dc0184cd61d883d1a4dd', class: "content" }, this.type === 'promo' ? h("h5", null, this.promoLabel) : icon ? h("wui-icon", { size: "md", name: icon }) : undefined, h("div", { key: '9607345cbe62ebb2b951ea5837b9406a975b3d35' }, h("slot", { key: '25d217390bc465b71e375dc47c16ca625ac52681' }))), this.dismissible && (h("div", { key: '17147e73c7a9399f0fecdbd15584585b2a48e427', class: "actions" }, h("hr", { key: 'db78b21a4ae133fbed46e2d3f001412ce63900e5' }), h("wui-close-button", { key: 'c16b23aeb4a9d4c9d27dae15632fecceb3bad501', onClick: this.handleDismiss, type: this.type === 'promo' ? 'bold' : 'muted' })))));
    }
    get el() { return this; }
    static get style() { return WuiAlertStyle0; }
}, [1, "wui-alert", {
        "dismissible": [4],
        "type": [513],
        "promoLabel": [1, "promo-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-alert", "wui-close-button", "wui-icon", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-alert":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiAlert$1);
            }
            break;
        case "wui-close-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement$1();

const WuiAlert = WuiAlert$1;
const defineCustomElement = defineCustomElement$1;

export { WuiAlert, defineCustomElement };

//# sourceMappingURL=wui-alert.js.map